/**
 * Created by Dushyantha on 19/05/16.
 */
'use strict';

(function () {
    angular
        .module('flightWatch')
        .component('flightWatchComponent', {
            templateUrl: 'flight-watch/components/flight-watch-component.tpl.html',
            controller: function (ContextMenuService, EventManagerService, SlideInPanelService, MessageService, $q, FlightWatch,PopupManager,$interval,CommonMasterData, $window, $timeout) {
                var vm = this;
                vm.posX = 0;
                vm.posY = 0;
                vm.min_screen_width = 1200;
                vm.screen_left_panel =180;
                vm.next_day_width = 200;
                vm.screen_right_panel = 800;
                vm.dayWidthInPx = 800;
                vm.top_header_width=975;
                vm.minimum_number_of_days = 1;
                vm.calendarData = [];
                vm.actual_screen_width = screen.width;
                vm.scrollAreaWidth = 0;
                vm.openFlightViewDisplay = false;
                vm.selctedOpenFlight = '';
                vm.addedFlightDetails = {};
                vm.addedFlightDetails.flightDetails = [];
                vm.addedFlightDetails.timeZone = 'UTC';
                vm.addedFlightDetails.updatedChecks = [];
                vm.addedFlightDetails.newChecks = [];
                vm.addedFlightDetails.deletedChecks = []
                vm.selectedType = '';
                vm.previosRowNo = '';
                vm.selectedAircraft= '';
                vm.selectedAnyAircraft = false;
                vm.selctedFlightIDforCheck='';
                vm.checkTypeStatus = '';
                vm.userActive=false;
                vm.refreshTime='';
                vm.refreshTimer = null;
                vm.notificationTime ='';
                vm.notificationTimer =null;
                vm.isNotification =false;
                vm.autoRefresh = false;
                vm.counter = 30;
                vm.decreaseCounter = null;
                vm.baseList='';
                vm.comHeight = 70 + angular.element("div.row.flight-watch-view").height() + angular.element("div.header-col.number").height() + angular.element("div.row.flight-watch-footer").height();
                vm.popOverModel = {}
                vm.popOverRequestFlightId = [];
                vm.popOverRequestModel = [];
                vm.multiSelectedFlightLegIdexes=[];
                vm.multiSelectedFlightLegBorderState=false;
                vm.FlightLegIdexes=0;
                vm.a=null;
                vm.previousSelectPairDetail={};
                vm.selectedPairDetails = [];
                vm.dragStartPoint = 0;
                vm.dragEndPoint = 0;
                vm.showBottomContaint= false;
                vm.aeroOpsEnableParam= false;
                loadBaseType();
                getAeroOpsEnableParam();


                EventManagerService.registerEventListener("set.flight.rotation", setFlightRotation);
                EventManagerService.registerEventListener("show.open.flight.view", showOpenFlightView);

                EventManagerService.registerEventListener(EventManagerService.EVENT.SPACEBAR.SAVE_ROTATION, saveRotation);
                EventManagerService.registerEventListener(EventManagerService.EVENT.SPACEBAR.RELOAD_ROTATION, reloadRotation);

                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.SEND_ROT_CNG_EMAIL, sendRotationChageEmail);

                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.SEND_ROT_EMAIL, sendRotationEmail);

                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.SHOW_ROTATION_SUMMARY, showRotationSummaryPopUp);

                EventManagerService.registerEventListener(EventManagerService.EVENT.SPACEBAR.CLICK_NEW_CHECK, openFlightCheckPopUp);
                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CHANGE_REFRESH_TIME, refreshRotationData);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.EDIT_CHECK,function(data){
                    vm.checkDetails=data.items.check;
                    vm.selctedFlightIDforCheck= data.items.$parent.$parent.$index;
                    vm.slectedCheckIndex = data.items.$parent.$index;
                    openFlightEditCheckPopUp();
                    //SlideInPanelService.openPanel('flightWatch.right.panel');
                });
              EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.SHOW_LOG, checkLogDetails);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.UPDATE_DELETE_CHECK_LIST, updateDeleteAircraftCheckList);

                EventManagerService.registerEventListener(EventManagerService.EVENT.FLIGHT_WATCH.SEARCH, clearAddedFlightDetails);

                function clearAddedFlightDetails(){
                            	  vm.addedFlightDetails = {};
                                  vm.addedFlightDetails.flightDetails = [];
                                  vm.addedFlightDetails.timeZone = 'UTC';
                                  vm.addedFlightDetails.updatedChecks = [];
                                  vm.addedFlightDetails.newChecks = [];
                                  vm.addedFlightDetails.deletedChecks = []
                              };

                if (!!vm.actual_screen_width && vm.actual_screen_width > vm.min_screen_width) {
                    vm.screen_right_panel = vm.actual_screen_width - vm.screen_left_panel - vm.next_day_width;
                    //vm.top_header_width  = vm.actual_screen_width - vm.screen_left_panel-10;                //scroll bar width = 10
                    vm.top_header_width  = angular.element('.right-section').width() + 184 - vm.screen_left_panel - 10;                //scroll bar width = 10, actual screen width 274 + right section width
                    vm.dayWidthInPx = vm.screen_right_panel;
                    vm.minuteToPixelRatio = (vm.dayWidthInPx) / (24 * 60);
                    vm.hour_width = vm.dayWidthInPx / 24;                                                   //for 24 view
                    vm.half_day_width = vm.dayWidthInPx / 2;                                                 // for am,pm view
                }
                if(angular.element(".tabbed-view-container").height() < 40){
                	angular.element(".tabbed-view-container").height(40);
                }
                var height= Math.max($("header").height() + $(".tabbed-view-container").height() + $(".space_bar").height(), 170)+"px";
            	angular.element(".canvas").css("top", height);

                angular.element($window).bind('resize', function () {
                	vm.comHeight = 70 + angular.element("div.row.flight-watch-view").height() + angular.element("div.header-col.number").height() + angular.element("div.row.flight-watch-footer").height();
                	if(vm.flightRotationData.length != 0){
                		vm.top_header_width  = angular.element('.right-section').width() + 184 - vm.screen_left_panel - 10;                //scroll bar width = 10, actual screen width 274 + right section width
                	}
                });

                vm.$onChanges = function (changeObj) {

                    if (changeObj.viewMode && changeObj.viewMode.currentValue && (changeObj.viewMode.currentValue != changeObj.viewMode.previousValue)) {
                        vm.minimum_number_of_days = vm.viewMode == 'OneDay' ? 1 : 4;
                        vm.dayWidthInPx = Math.floor(vm.screen_right_panel / vm.minimum_number_of_days);
                        vm.minuteToPixelRatio = (vm.dayWidthInPx ) / (24 * 60);
                        vm.hour_width = (vm.dayWidthInPx ) / 24;
                        formatTemplate();
                        formatFlightData();
                        formatOpenFlightData();
                        vm.openFlightViewDisplay = false;


                    }
                    if (changeObj.flightRotationData && changeObj.flightRotationData.currentValue && (changeObj.flightRotationData.currentValue != changeObj.flightRotationData.previousValue)) {
                        formatTemplate();
                        formatFlightData();
//                        vm.openFlightViewDisplay = false;


                    }
                    if (changeObj.openFlightData && changeObj.openFlightData.currentValue && (changeObj.openFlightData.currentValue != changeObj.openFlightData.previousValue)) {
                        formatOpenFlightData();
                    }
                    if(changeObj.currentTimeModel && changeObj.currentTimeModel.currentValue && (changeObj.currentTimeModel.currentValue != changeObj.currentTimeModel.previousValue)) {
                        handleTimeBar();
                    }

                };

                function showOpenFlightView(flag){
                	vm.openFlightViewDisplay = flag;
//                	vm.clickOnOpenFlight();
                }

            function checkLogDetails(check){
                  var aircraftCheckId = check.items.$parent.check.aircraftRegCheckId;
              FlightWatch.checkLogDetails(aircraftCheckId,
                function (response) {
                  openShowLogsPopUp(response);
                },
                function () {
                  console.log('Flight check log details retrieval error');
                })

            }

              function openShowLogsPopUp(checkLogDetails){
                var modalParam = {
                  checkLogDetails: checkLogDetails
                };
                PopupManager.openModal('FLIGHT_CHECK_LOG_DETAILS', modalParam, closedSummaryPopUp);
              }

                function setFlightRotation(flightPairs){
                	 angular.forEach(flightPairs, function (pairDetail) {
                		 angular.forEach(pairDetail.left, function (flight) {
                			 if(flight.aircraftId !== null){
                				 vm.addedFlightDetails.flightDetails.push({'flightLegId': flight.flightLegId, 'aircraftId': flight.aircraftId});
                			 }
                			});
                		 angular.forEach(pairDetail.right, function (flight) {
                			 if(flight.aircraftId !== null){
                				 vm.addedFlightDetails.flightDetails.push({'flightLegId': flight.flightLegId, 'aircraftId': flight.aircraftId});
                			 }
                			});
                	 });
                }

                function updateDeleteAircraftCheckList(check){
                	vm.addedFlightDetails.deletedChecks.push({'aircraftRegCheckId': check.aircraftRegCheckId, 'version': check.version});
                }


                function getPairCalenderIndex(depDate, relativeTo) {
                	var mo_checkIn = moment(depDate, 'DD/MM/YYYY');
                    var diffFromStart = mo_checkIn.diff(relativeTo, 'm');
                    return (diffFromStart>0) ? diffFromStart/1440 : 0;
                }

                function getTimeInMinFromStartDate(depDate, depTime, relativeTo) {
                    var reqDate = depDate + ' ' + depTime;
                    var mo_checkIn = moment(reqDate, 'DD/MM/YYYY HH:mm');
                    var diffFromStart = mo_checkIn.diff(relativeTo, 'm');
                    return Math.round(diffFromStart * vm.minuteToPixelRatio);
                }
                function updateMinMax(yCol, index, start, end) {
                    if (angular.isUndefined(yCol[index])) {
                        yCol[index] = {};
                    }

                    if (angular.isUndefined(yCol[index].minDate) || start < yCol[index].minDate) {
                        yCol[index].minDate = start;
                    }

                    if (angular.isUndefined(yCol[index].maxDate) || end > yCol[index].maxDate) {
                        yCol[index].maxDate = end;
                    }
                }

                function getRowIndex(rowMinMax, start, end) {
                    var obj;
                    var rowIndex = -1;
                    for (var i = 0; i < rowMinMax.length; i++) {
                        obj = rowMinMax[i];
                        if (
                            (end.isSameOrBefore(rowMinMax[i].minDate, 'minute')) || (start.isSameOrAfter(rowMinMax[i].maxDate, 'minute'))
                            ) {
                            updateMinMax(rowMinMax, i, start, end);
                            rowIndex = i;
                            break;
                        }
                    }

                    if (rowIndex == -1) {
                        rowIndex = rowMinMax.length;
                        updateMinMax(rowMinMax, rowIndex, start, end);
                    }
                    return rowIndex;
                }
                function formatFlightData() {
                    var tmpPatternEndInPx;
                    var tmpCheckEndInPx;
                    var tmpINAPeriodEndInPx;
                    var dayStartTime = moment().startOf("day").format('HH:mm');
                    var dayEndTime = moment().endOf("day").format('HH:mm');

                    angular.forEach(vm.flightRotationData, function (pairDetail) {
                        var rowMinMax = [];
                        var tmpMomentStart;
                        var tmpMomentEnd;
                        angular.forEach(pairDetail.pairs, function (pair) {
                        	pair.top = 5;
                            var groupDepDate, groupArrDate, groupDepTime, groupArrTime, tmpGropEndIndex, groupStatDateTime,gropEndDateTime,rowIndex;
                            if (pair.left.length && pair.right.length) {
                                if(!!pair.left[0].actDeptDate){
                                    groupDepDate = pair.left[0].actDeptDate;
                                    groupDepTime = pair.left[0].actDeptTime;
                                }
                                else{
                                    groupDepDate = pair.left[0].estDeptDate;
                                    groupDepTime = pair.left[0].estDeptTime;
                                }
                                if(pair.right[(pair.right.length - 1)].actArvlDate){
                                    groupArrDate = pair.right[(pair.right.length - 1)].actArvlDate;
                                    groupArrTime = pair.right[(pair.right.length - 1)].actArvlTime;
                                }
                                else{
                                    groupArrDate = pair.right[(pair.right.length - 1)].estArvlDate;
                                    groupArrTime = pair.right[(pair.right.length - 1)].estArvlTime;
                                }
                                pair.leftPos = getTimeInMinFromStartDate(groupDepDate, groupDepTime, vm.cal_start);
                                tmpGropEndIndex = getTimeInMinFromStartDate(groupArrDate, groupArrTime, vm.cal_start);
                                pair.widthInPx = tmpGropEndIndex - pair.leftPos;

                                // dev
                                pair.calenderIndex = getPairCalenderIndex(groupDepDate, vm.cal_start);

                            }
                            else if (pair.left.length && !pair.right.length) {
                                if(!!pair.left[0].actDeptDate){
                                    groupDepDate = pair.left[0].actDeptDate;
                                    groupDepTime = pair.left[0].actDeptTime;
                                }
                                else{
                                    groupDepDate = pair.left[0].estDeptDate;
                                    groupDepTime = pair.left[0].estDeptTime;
                                }
                                if(pair.left[(pair.left.length - 1)].actArvlDate){
                                    groupArrDate = pair.left[(pair.left.length - 1)].actArvlDate;
                                    groupArrTime = pair.left[(pair.left.length - 1)].actArvlTime;
                                }
                                else{
                                    groupArrDate = pair.left[(pair.left.length - 1)].estArvlDate;
                                    groupArrTime = pair.left[(pair.left.length - 1)].estArvlTime;
                                }

                                pair.leftPos = getTimeInMinFromStartDate(groupDepDate, groupDepTime, vm.cal_start);
                                tmpGropEndIndex = getTimeInMinFromStartDate(groupArrDate, groupArrTime, vm.cal_start);
                                pair.widthInPx = tmpGropEndIndex - pair.leftPos;

                                // dev
                                pair.calenderIndex = getPairCalenderIndex(groupDepDate, vm.cal_start);

                            }
                            else if (!pair.left.length && pair.right.length) {
                                if(!!pair.right[0].actDeptDate){
                                    groupDepDate = pair.right[0].actDeptDate;
                                    groupDepTime = pair.right[0].actDeptTime;
                                }
                                else{
                                    groupDepDate = pair.right[0].estDeptDate;
                                    groupDepTime = pair.right[0].estDeptTime;
                                }
                                if(pair.right[(pair.right.length - 1)].actArvlDate){
                                    groupArrDate = pair.right[(pair.right.length - 1)].actArvlDate;
                                    groupArrTime = pair.right[(pair.right.length - 1)].actArvlTime;
                                }
                                else{
                                    groupArrDate = pair.right[(pair.right.length - 1)].estArvlDate;
                                    groupArrTime = pair.right[(pair.right.length - 1)].estArvlTime;
                                }
                                pair.leftPos = getTimeInMinFromStartDate(groupDepDate, groupDepTime, vm.cal_start);
                                tmpGropEndIndex = getTimeInMinFromStartDate(groupArrDate, groupArrTime, vm.cal_start);
                                pair.widthInPx = tmpGropEndIndex - pair.leftPos;

                                // dev
                                pair.calenderIndex = getPairCalenderIndex(groupDepDate, vm.cal_start);
                            }
                            groupStatDateTime = moment(groupDepDate + ' ' + groupDepTime, 'DD/MM/YYYY HH:mm');
                            gropEndDateTime = moment(groupArrDate + ' ' + groupArrTime, 'DD/MM/YYYY HH:mm');
                            rowIndex = getRowIndex(rowMinMax, groupStatDateTime, gropEndDateTime);
                            pair.rowIndex = rowIndex;

                            /*if(rowIndex === 0){
                                pair.top = 5;
                            }
                            else{
                                pair.top = 0;
                            }*/

                            // check for overlap
                            setOverLapPair(pair, pairDetail.pairs);
                            setGroundTimeBar(pair);

                            var pairMinMax=[];
                            if (pair.left.length) {
                                var pairStatDateTime,pairEndDateTime,pairRowIndex
                                angular.forEach(pair.left, function (left) {

                                    left.leftPos = 0;
                                    left.widthInPx = 0;

                                    //left.leftPos = getTimeInMinFromStartDate(left.estDeptDate, left.estDeptTime, groupStatDateTime);
                                    //tmpPatternEndInPx = getTimeInMinFromStartDate(left.estArvlDate, left.estArvlTime, groupStatDateTime);
                                    if(!!left.actDeptDate){
                                        left.leftPos = getTimeInMinFromStartDate(left.actDeptDate, left.actDeptTime, groupStatDateTime);
                                        pairStatDateTime = moment(left.actDeptDate + ' ' + left.actDeptTime, 'DD/MM/YYYY HH:mm');
                                    }
                                    else{
                                        left.leftPos = getTimeInMinFromStartDate(left.estDeptDate, left.estDeptTime, groupStatDateTime);
                                        pairStatDateTime = moment(left.estDeptDate + ' ' + left.estDeptTime, 'DD/MM/YYYY HH:mm');
                                    }
                                    if(left.actArvlDate){
                                        tmpPatternEndInPx = getTimeInMinFromStartDate(left.actArvlDate, left.actArvlTime, groupStatDateTime);
                                        pairEndDateTime = moment(left.actArvlDate + ' ' + left.actArvlTime, 'DD/MM/YYYY HH:mm');
                                    }
                                    else{
                                        tmpPatternEndInPx = getTimeInMinFromStartDate(left.estArvlDate, left.estArvlTime, groupStatDateTime);
                                        pairEndDateTime = moment(left.estArvlDate + ' ' + left.estArvlTime, 'DD/MM/YYYY HH:mm');
                                    }
                                    pairRowIndex = getRowIndex(pairMinMax, pairStatDateTime, pairEndDateTime);
                                    left.pairRowIndex=pairRowIndex;
                                    left.widthInPx = tmpPatternEndInPx - left.leftPos;
                                    left.startPosition = left.leftPos;
                                    left.endPosition = tmpPatternEndInPx - 18;
                                    //left.backgroundColour = setBackgroundColour(left,pair.rowIndex,pairRowIndex);
                                    left.backgroundColour = setBackgroundColour(left, true); //not binding overlapping color to left flight for clarity of identifying
                                    left.pairStatus = getPairStatus(left);
                                    if (left.departureDelay != 0  && left.departureDelay > 0) {
                                        left.departureDelayLeftPos = getTimeInMinFromStartDate(left.estDeptDate, left.estDeptTime, groupStatDateTime);
                                        left.departureDelayWidth = Math.round(left.departureDelay * vm.minuteToPixelRatio);
                                    }
                                    if (left.arrivalDelay != 0  && left.arrivalDelay > 0) {
                                        left.arrivalDelayLeftPos = getTimeInMinFromStartDate(left.estArvlDate, left.estArvlTime, groupStatDateTime);
                                        left.arrivalDelayWidth = Math.round(left.arrivalDelay * vm.minuteToPixelRatio);
                                    }
                                    if (left.groundTime != 0 ) {
                                        left.groundTimeLeftPos = tmpPatternEndInPx;
                                        left.groundTimeWidth = Math.round(left.groundTime * vm.minuteToPixelRatio);
                                    }
                                  if (left.flightUpdateStatus != null && left.slotMessageTitle != null ) {
                                      var endPosition = tmpPatternEndInPx;
                                      if(left.arrivalDelayLeftPos != null &&  left.arrivalDelayLeftPos  > 0){
                                        endPosition = left.arrivalDelayLeftPos;
                                      }
                                    left.slotMessageIconLeftPos = endPosition - 18;
                                    left.slotMessageIconLeftWidth = 18;

                                  }


                                });
                            }
                            if (pair.right.length) {
                                angular.forEach(pair.right, function (right) {
                                    right.leftPos = 0;
                                    right.widthInPx = 0;
                                    //right.leftPos = getTimeInMinFromStartDate(right.estDeptDate, right.estDeptTime, groupStatDateTime);
                                    //tmpPatternEndInPx = getTimeInMinFromStartDate(right.estArvlDate, right.estArvlTime, groupStatDateTime);
                                    if(!!right.actDeptDate){
                                        right.leftPos = getTimeInMinFromStartDate(right.actDeptDate, right.actDeptTime, groupStatDateTime);
                                        pairStatDateTime = moment(right.actDeptDate + ' ' + right.actDeptTime, 'DD/MM/YYYY HH:mm');
                                    }
                                    else{
                                        right.leftPos = getTimeInMinFromStartDate(right.estDeptDate, right.estDeptTime, groupStatDateTime);
                                        pairStatDateTime = moment(right.estDeptDate + ' ' + right.estDeptTime, 'DD/MM/YYYY HH:mm');
                                    }
                                    if(right.actArvlDate){
                                        tmpPatternEndInPx = getTimeInMinFromStartDate(right.actArvlDate, right.actArvlTime, groupStatDateTime);
                                        pairEndDateTime = moment(right.actArvlDate + ' ' + right.actArvlTime, 'DD/MM/YYYY HH:mm');
                                    }
                                    else{
                                        tmpPatternEndInPx = getTimeInMinFromStartDate(right.estArvlDate, right.estArvlTime, groupStatDateTime);
                                        pairEndDateTime = moment(right.estArvlDate + ' ' + right.estArvlTime, 'DD/MM/YYYY HH:mm');
                                    }
                                    pairRowIndex = getRowIndex(pairMinMax, pairStatDateTime, pairEndDateTime);
                                    right.pairRowIndex=pairRowIndex;
                                    right.widthInPx = tmpPatternEndInPx - right.leftPos;
                                    right.startPosition = right.leftPos;
                                    right.endPosition = tmpPatternEndInPx -18;
                                    right.backgroundColour = setBackgroundColour(right, pair.notOverlap);
                                    right.pairStatus = getPairStatus(right);
                                    if (right.departureDelay != 0 && right.departureDelay > 0) {
                                        right.departureDelayLeftPos = getTimeInMinFromStartDate(right.estDeptDate, right.estDeptTime, groupStatDateTime);
                                        right.departureDelayWidth = Math.round(right.departureDelay * vm.minuteToPixelRatio);
                                    }
                                    if (right.arrivalDelay != 0 && right.arrivalDelay > 0) {
                                        right.arrivalDelayLeftPos = getTimeInMinFromStartDate(right.estArvlDate, right.estArvlTime, groupStatDateTime);
                                        right.arrivalDelayWidth = Math.round(right.arrivalDelay * vm.minuteToPixelRatio);
                                    }
                                    if (right.groundTime != 0) {
                                        right.groundTimeLeftPos = tmpPatternEndInPx;
                                        right.groundTimeWidth = Math.round(right.groundTime * vm.minuteToPixelRatio);
                                    }
                                    if (right.flightUpdateStatus != null && right.slotMessageTitle != null ) {
                                        var endPosition = tmpPatternEndInPx;
                                        if(right.arrivalDelayLeftPos != null &&  right.arrivalDelayLeftPos  > 0){
                                          endPosition = right.arrivalDelayLeftPos;
                                        }
                                        right.slotMessageIconLeftPos = endPosition - 18;
                                        right.slotMessageIconLeftWidth = 18;

                                  }

                                });
                            }
                        });



                        var checkRowMinMax=[];
                        angular.forEach(pairDetail.checks, function (check) {
                            var checkStatDateTime,checkEndDateTime='';
                            check.displayLabel =getCheckDisplayLabel(check);
                            check.leftPos = 0;
                            check.widthInPx = 0;
                            check.leftPos = getTimeInMinFromStartDate(check.checkStartDate, check.checkStartTime, vm.cal_start);
                            tmpCheckEndInPx = getTimeInMinFromStartDate(check.checkEndDate, check.checkEndTime, vm.cal_start);
                            check.widthInPx = tmpCheckEndInPx - check.leftPos;
                            checkStatDateTime = moment(check.checkStartDate + ' ' + check.checkStartTime, 'DD/MM/YYYY HH:mm');
                            checkEndDateTime = moment(check.checkEndDate + ' ' + check.checkEndTime, 'DD/MM/YYYY HH:mm');
                            check.rowIndex = getRowIndex(checkRowMinMax, checkStatDateTime, checkEndDateTime);
                            /*if(check.rowIndex === 0 ){
                                check.top = 10;
                                check.notOverlap =true;
                            }
                            else{
                                check.top= 10-5;
                                check.notOverlap = false;
                            }*/
                          setNotOverLap(check, pairDetail);
                        });
                        var inaPeriodRowMinMax=[]
                        angular.forEach(pairDetail.acInactivePeriods, function (acInactivePeriod) {

                            var inaStartDateTime, inaEndDateTime = '';

                            acInactivePeriod.displayLabel = 'AC Inactive Period';
                            acInactivePeriod.leftPos = 0;
                            acInactivePeriod.widthInPx = 0;

                            acInactivePeriod.leftPos = getTimeInMinFromStartDate(acInactivePeriod.inActiveStartDate, dayStartTime, vm.cal_start);

                            tmpINAPeriodEndInPx = getTimeInMinFromStartDate(acInactivePeriod.inActiveEndDate, dayEndTime, vm.cal_start);
                            acInactivePeriod.widthInPx = tmpINAPeriodEndInPx - acInactivePeriod.leftPos;

                            inaStartDateTime = moment(acInactivePeriod.checkStartDate + ' ' + acInactivePeriod.checkStartTime, 'DD/MM/YYYY HH:mm');
                            inaEndDateTime = moment(acInactivePeriod.checkEndDate + ' ' + acInactivePeriod.checkEndTime, 'DD/MM/YYYY HH:mm');
                            acInactivePeriod.rowIndex = getRowIndex(inaPeriodRowMinMax, inaStartDateTime, inaEndDateTime);

                            if(acInactivePeriod.rowIndex === 0 ){
                            	acInactivePeriod.top = 10;
                            	acInactivePeriod.notOverlap = true;
                            }
                            else{
                            	acInactivePeriod.top= 10-5;
                            	acInactivePeriod.notOverlap = false;
                            }
                        });
                    });
                }


                function setGroundTimeBar(pair) {
                	pair.groundTimeBar = true;

                	angular.forEach(pair.left, function(flightleg){
                		flightleg.gtime = flightleg.groundTime * vm.minuteToPixelRatio;
                	});

                	angular.forEach(pair.right, function(flightleg){
                		flightleg.gtime = flightleg.groundTime * vm.minuteToPixelRatio;
                	});
                }

                function setOverLapPair(pair, pairDetail) {

                	pair.top = 0;
                	pair.notOverlap = true;

                	angular.forEach(pair.left, function(flightleg){

                		 angular.forEach(pairDetail, function(flightPairs){
                			 angular.forEach(flightPairs.left, function(lp){
                				 if(lp.legStartTimeMillis < flightleg.legEndTimeMillis &&
                						 lp.legEndTimeMillis > flightleg.legStartTimeMillis &&
                						 	flightleg.flightLegId != lp.flightLegId ){
                				   pair.top = 5;
                                   pair.notOverlap = false;
                				 }
                    		 });

                			 angular.forEach(flightPairs.right, function(rp){
                				 if(rp.legStartTimeMillis < flightleg.legEndTimeMillis &&
                						 rp.legEndTimeMillis > flightleg.legStartTimeMillis  &&
                						 	flightleg.flightLegId != rp.flightLegId ){
                				   pair.top = 5;
                                   pair.notOverlap = false;
                				 }
                    		 });

                		 });

                	});

                	angular.forEach(pair.right, function(flightleg){

	               		 angular.forEach(pairDetail, function(flightPairs){
	               			 angular.forEach(flightPairs.left, function(lp){
	               				 if(lp.legStartTimeMillis < flightleg.legEndTimeMillis &&
	               						 lp.legEndTimeMillis > flightleg.legStartTimeMillis  &&
	               						 	flightleg.flightLegId != lp.flightLegId){
	               				   pair.top = 5;
	                               pair.notOverlap = false;
	               				 }
	                   		 });

	               			 angular.forEach(flightPairs.right, function(rp){
	               				 if(rp.legStartTimeMillis < flightleg.legEndTimeMillis &&
	               						 rp.legEndTimeMillis > flightleg.legStartTimeMillis  &&
	               						 	flightleg.flightLegId != rp.flightLegId ){
	               				   pair.top = 5;
	                               pair.notOverlap = false;
	               				 }
	                   		 });

	               		 });

                	});

                }


                function setNotOverLap(check, pairDetail) {
                  var leftPos = check.leftPos;
                  var rightPos = leftPos + check.widthInPx;
                  // default
                  check.top = 0;
                  check.notOverlap = true;

                  // check with pairs
                  angular.forEach(pairDetail.checks, function(value, key){
                    if(check.aircraftRegCheckId !== value.aircraftRegCheckId) {
                      var chLeftPos = value.leftPos;
                      var chRightPos = chLeftPos + value.widthInPx;
                      if ((leftPos < chRightPos) && (chLeftPos < rightPos)) {
                        check.top = 0;
                        check.notOverlap = false;
                      }
                    }
                  });

                  // check with pairs
                  angular.forEach(pairDetail.pairs, function(value, key){
                    var paLeftPos = value.leftPos;
                    var paRightPos = paLeftPos + value.widthInPx;
                    if((leftPos < paRightPos) && (paLeftPos < rightPos)){
                      check.top= 0;
                      check.notOverlap = false;
                    }
                  });
                }

                function formatTemplate() {
                    vm.cal_start = moment(vm.fromDate, "DD/MM/YYYY");
                    vm.cal_end = moment(vm.toDate, 'DD/MM/YYYY');
                    var dateDiff = vm.cal_end.diff(vm.cal_start, 'days');

                    if (dateDiff < vm.minimum_number_of_days) {
                        dateDiff = vm.minimum_number_of_days;
                    }

                    /*Prepare Calendar Data*/
                    var tmp;
                    vm.calendarData.length = 0;
                    vm.scrollAreaWidth = 0;
                    for (var i = 0; i <= dateDiff; i++) {
                        tmp = moment(vm.cal_start).add(i, 'd');
                        vm.calendarData.push({
                            date: tmp.format('DD/MM/YYYY'),
                            dayOfWeekShort: tmp.format('dd'),
                            left: (vm.dayWidthInPx * i)
                        });
                        vm.scrollAreaWidth += vm.dayWidthInPx;
                    }

                }

                function handleTimeBar(){
                    vm.timeLineLeftPos = getTimeInMinFromStartDate(vm.currentTimeModel.localDate, vm.currentTimeModel.localTime, vm.cal_start);
                }

                function setBackgroundColour(pair, notOverlap) {

                    var backgroundColour = '';
                    pair.isOverlap = false;
                    /*if(rowIndex !== 0 || pairRowIndex !==0){
                        backgroundColour = "#d91010";
                        pair.isOverlap = true;
                    }*/
                    if(!notOverlap){
                      backgroundColour = "#d91010";
                      pair.isOverlap = true;
                    }
                    else if (pair.airportExclution) {
                        backgroundColour = "#d91010";
                    }
                    else if (pair.aircraftModelValidationFlag) {
                        backgroundColour = "#d91010";
                    }
                    else if (pair.etopsFlag && !pair.flightDeparture) {
                        backgroundColour = "#FF5E07";
                    }
                    else if (pair.baseFlight && pair.in) {
                        backgroundColour = "#214f7b"
                    }
                    else if (pair.baseFlight && pair.off) {
                        backgroundColour = "#1d4c79"
                    }
                    else if (!pair.baseFlight && pair.in) {
                        // backgroundColour = "#087984"
                        backgroundColour = "#4DB6AC"
                    }
                    else if (!pair.baseFlight && pair.off) {
                        backgroundColour = "#1fcfda"
                    }
                    else if (pair.baseFlight) {
                        backgroundColour = '#e6bc15';
                    }
                    else if (!pair.baseFlight) {
                        // backgroundColour = '#4DB6AC';
                        backgroundColour = '#087984';
                    }
                    else {
                        backgroundColour = '#087984';   //return flight
                    }
                    return backgroundColour;
                }

                function getPairStatus(pair) {
                    var status = '';
                    if (pair.on) {
                        status = 'on';
                    }
                    else if (pair.in) {
                        status = 'in';
                    }
                    else if (pair.off) {
                        status = 'off';
                    }
                    else if (pair.out) {
                        status = 'out';
                    }
                    return status;
                }

                vm.loadOpenFlights = function () {
                    if (!vm.openFlightButtonDisable) {
                        vm.openFlightViewDisplay = !vm.openFlightViewDisplay;
                        if (vm.openFlightViewDisplay && !vm.openFlightData.length) {
                            vm.clickOnOpenFlight();
                        }
                    }

                };

                function formatOpenFlightData() {
                    var tempFlightEnd;
                    angular.forEach(vm.openFlightData, function (openFlight) {
                        var groupDepDate, groupArrDate, groupDepTime, groupArrTime, tmpGropEndIndex, groupStatDateTime;
                        if (openFlight.rowIndex === 0) {
                            openFlight.top = 80;
                        }
                        else {
                            openFlight.top = 80 + (openFlight.rowIndex * 42);
                        }
                        groupDepDate = openFlight.pairStartDate;
                        groupDepTime = openFlight.pairStartTime;
                        groupArrDate = openFlight.pairEndDate;
                        groupArrTime = openFlight.pairEndTime;
                        openFlight.leftPos = getTimeInMinFromStartDate(groupDepDate, groupDepTime, vm.cal_start);
                        tmpGropEndIndex = getTimeInMinFromStartDate(groupArrDate, groupArrTime, vm.cal_start);
                        openFlight.widthInPx = tmpGropEndIndex - openFlight.leftPos + 2;
                        groupStatDateTime = moment(openFlight.pairStart, 'DD/MM/YYYY HH:mm');


                        if (openFlight.left != null) {
                            angular.forEach(openFlight.left, function (left) {
                                left.leftPos = 0;
                                left.widthInPx = 0;
                                left.leftPos = getTimeInMinFromStartDate(left.estDeptDate, left.estDeptTime, groupStatDateTime);
                                tempFlightEnd = getTimeInMinFromStartDate(left.estArvlDate, left.estArvlTime, groupStatDateTime);
                                left.widthInPx = tempFlightEnd - left.leftPos;
                                //left.backgroundColour = setBackgroundColour(left);//#778590
                                left.openBackgroundColour = '#778590';
                                left.pairStatus = getPairStatus(left);
                                /*if(left.groundTime !=0){
                                 left.groundTimeLeftPos = tmpPatternEndInPx;
                                 left.groundTimeWidth = Math.round(left.groundTime * vm.minuteToPixelRatio) ;
                                 }*/
                            });
                        }
                        if (openFlight.right != null) {
                            angular.forEach(openFlight.right, function (right) {
                                right.leftPos = 0;
                                right.widthInPx = 0;
                                right.leftPos = getTimeInMinFromStartDate(right.estDeptDate, right.estDeptTime, groupStatDateTime);
                                tempFlightEnd = getTimeInMinFromStartDate(right.estArvlDate, right.estArvlTime, groupStatDateTime);
                                right.widthInPx = tempFlightEnd - right.leftPos;
                                //right.backgroundColour = setBackgroundColour(right); //#778590
                                right.openBackgroundColour = '#778590';
                                right.pairStatus = getPairStatus(right);

                                /*if(right.groundTime !=0){
                                 right.groundTimeLeftPos = tmpPatternEndInPx;
                                 right.groundTimeWidth = Math.round(right.groundTime * vm.minuteToPixelRatio) ;
                                 }*/
                            });
                        }

                    });
                }

                vm.moveOnBlock = function (e, flObj, rowIndex) {
                    var findPosition = function () {
                        var H = 'left', V = 'top';
                        if ((e.clientX + e.target.offsetWidth + 100) > vm.screen_right_panel) {
                            H = 'left';
                        } else {
                            H = 'right';
                        }
                        if ((e.clientY + e.target.offsetHeight + 100) > vm.comHeight) {
                            V = 'bottom';
                        } else {
                            V = 'top';
                        }
                        return H + '-' + V;
                    };
                    /*var isOverlap =false
                    if(rowIndex !==0){
                        isOverlap =true;
                    }*/
                    vm.toolTipModel = {
                        placement: findPosition(),
                        origin: flObj.origin,
                        destination: flObj.destination,
                        estDeptTime: flObj.actDeptTime,
                        estArvlTime: flObj.actArvlTime,
                        flightNumber: flObj.flightNumber,
                        atcCallSign: flObj.atcCallSign,
                        atcCallSignFlag: flObj.atcCallSignFlag,
                        timeZone: vm.timeZone,
                        airportExclution: flObj.airportExclution,
                        exclutionAirports: flObj.exclutionAirports,
                        aircraftModelValidationFlag: flObj.aircraftModelValidationFlag,
                        isOverlap: flObj.isOverlap
                    };
                };

              vm.moveOnMisConnection = function (e, flObj, isLeft) {
                var findPosition = function () {
                  var H = 'left', V = 'top';
                  if ((e.clientX + e.target.offsetWidth + 100) > vm.screen_right_panel) {
                    H = 'left';
                  } else {
                    H = 'right';
                  }
                  if ((e.clientY + e.target.offsetHeight + 100) > vm.comHeight) {
                    V = 'bottom';
                  } else {
                    V = 'top';
                  }
                  return H + '-' + V;
                };

                var flights = [];
                if(isLeft){
                  flights = flObj.inBoundMisconnectionFlights;
                } else {
                  flights = flObj.outBoundMisconnectionFlights;
                }

                vm.toolTipModel = {
                  placement: findPosition(),
                  flights: flights
                };
              };

                vm.moveOnOpenFlight = function (e, flObj) {
                    var findPosition = function () {
                        var H = 'left', V = 'top';
                        if ((e.clientX + e.target.offsetWidth + 100) > vm.screen_right_panel) {
                            H = 'left';
                        } else {
                            H = 'right';
                        }
                        if ((e.clientY + e.target.offsetHeight + 100) > vm.comHeight) {
                            V = 'bottom';
                        } else {
                            V = 'top';
                        }
                        return H + '-' + V;
                    };

                    vm.toolTipModel = {
                        placement: findPosition(),
                        origin: flObj.origin,
                        destination: flObj.destination,
                        estDeptTime: flObj.actDeptTime,
                        estArvlTime: flObj.actArvlTime,
                        flightNumber: flObj.flightNumber,
                        atcCallSign: flObj.atcCallSign,
                        atcCallSignFlag: flObj.atcCallSignFlag,
                        timeZone: vm.timeZone,
                        airportExclution: flObj.airportExclution,
                        exclutionAirports: flObj.exclutionAirports,
                        aircraftModelValidationFlag: flObj.aircraftModelValidationFlag,
                        isOverlap: flObj.isOverlap,
                        modelNo: flObj.modelNo
                    };
                };

                vm.moveOnCheck =function (e, flObj) {
                    vm.toolTipCheckModel = flObj;
                    vm.toolTipCheckModel.placement = findPosition(e);
                };

                function findPosition(e){
                	var H = 'left', V = 'top';
                    if ((e.clientX + e.target.offsetWidth + 100) > vm.screen_right_panel) {
                        H = 'left';
                    } else {
                        H = 'right';
                    }
                    if ((e.clientY + e.target.offsetHeight + 100) > vm.comHeight) {
                        V = 'bottom';
                    } else {
                        V = 'top';
                    }
                    return H + '-' + V;
                }

                vm.moveOnINAPeriod = function(event, inaPeriod){
                	 vm.toolTipINAPeridModel = inaPeriod
                     vm.toolTipINAPeridModel.placement = findPosition(event);
                };

                vm.getContextMenuContent = function (type, duty) {
                  if(checkSelectedFlightsSaved(duty) && !(vm.aeroOpsEnableParam)) {
                    if (type === 'duty' && vm.selectedPairDetails.length <= 1) {
                      return ContextMenuService.getContextMenu('UPDATE_FLIGHT');
                    } else if (type === 'duty' && vm.selectedPairDetails.length > 1) {
                      return ContextMenuService.getContextMenu('CREW_WATCH_SEND_CREW_NOTIFICATION');
                    }
                    else if (type === 'check' && duty.aircraftRegCheckId) {
                      return ContextMenuService.getContextMenu('EDIT_CHECK');
                    }
                  } else {
                    return [];
                  }
                };

                function checkSelectedFlightsSaved(duty) {
                  var isRightClickAvailable = true;
                  angular.forEach(vm.addedFlightDetails.flightDetails, function (flight) {
                      if (flight.flightLegId == duty.flightLegId) {
                        isRightClickAvailable = false;
                      }
                  });
                  return isRightClickAvailable;
                }

                vm.toggleRightPanelClick = function () {
                    SlideInPanelService.toggle('flightWatch.right.panel');
                };

                vm.onBeforeOpenFlightDrag = function (event, dragEle, selectedFlight, id, type) {
                	var modelNo = selectedFlight.modelNo;
                	vm.selctedFlight = selectedFlight;
                	vm.selectedType = type;
                	setSelectableRows(modelNo);

                	vm.draggedFlightId = id;

                	var dropElePos = dragEle.position.top;
                	var creScheduleTop = angular.element('.canvas').position().top + 60;
                	var openParingPanelTop = angular.element('.bottom-content-open-flight-view').position().top - 20;

                	if ((dropElePos > creScheduleTop && dropElePos < openParingPanelTop) && vm.selectedType === 'open') {
                		vm.openFlightData.splice(vm.draggedFlightId, 1);
                	}
                	else{
                		clearSelectableRows();
                	}


                	/*$interval(function () {
                     if(!!angular.element('.selected-row:first')){
                     var offset = angular.element('.selected-row:first').offset()
                     var selectedFistRowPosition = offset.top;
                     if(selectedFistRowPosition>200){
                     selectedFistRowPosition = selectedFistRowPosition-200;
                     }
                     angular.element('.left-section').scrollTop(selectedFistRowPosition);
                     }
                     },1000,1);*/
                };

                vm.onFlightDrop = function (e, dragEle, data, id) {

                	if (vm.selectedType === 'check') {
                		var currentPosition = dragEle.offset.left - 250;
                		updateSelectedCheck(currentPosition,data);
                	}
                	else {
                      if(vm.selctedFlight){
                          if (data.modelNumber === vm.selctedFlight.modelNo) {

                            EventManagerService.notifyEventListeners("remove.flight.leg.from.rotation",
                              {'flightLegId': vm.selctedFlight.left[0].flightLegId ,'aircraftId': vm.selctedFlight.left[0].aircraftId});

                            if(vm.selectedType != 'open'){
                              if (!!vm.selctedFlight.left) {
                                angular.forEach(vm.selctedFlight.left, function (flight) {
                                  vm.addedFlightDetails.flightDetails.push({'flightLegId': flight.flightLegId, 'aircraftId': data.registrationID});
                                });
                              }
                              if (!!vm.selctedFlight.right) {
                                angular.forEach(vm.selctedFlight.right, function (flight) {
                                  vm.addedFlightDetails.flightDetails.push({'flightLegId': flight.flightLegId, 'aircraftId': data.registrationID});
                                });
                              }
                              vm.selctedFlight.top = 5;
                              setFlightAircraftRegIdOfPair(vm.selctedFlight,data.registrationID);
                              EventManagerService.notifyEventListeners("add.flight.leg.to.rotation",
                                {'flightPair': vm.selctedFlight,'aircraftId': data.registrationID});

    //                				vm.flightRotationData[id].pairs.push(vm.selctedFlight);
                            }
                            var dropElePos = dragEle.position.top;
                            var creScheduleTop = angular.element('.canvas').position().top + 60;
                            var openParingPanelTop = angular.element('.bottom-content').position().top - 20;

                            if(vm.selectedType === 'open'){
                              vm.openFlightData.splice(vm.draggedFlightId, 1);
                              vm.draggedFlightId="";

                              if (dropElePos > creScheduleTop && dropElePos < openParingPanelTop) {
                                if (!!vm.selctedFlight.left) {
                                  angular.forEach(vm.selctedFlight.left, function (flight) {
                                    vm.addedFlightDetails.flightDetails.push({'flightLegId': flight.flightLegId, 'aircraftId': data.registrationID});
                                  });
                                }
                                if (!!vm.selctedFlight.right) {
                                  angular.forEach(vm.selctedFlight.right, function (flight) {
                                    vm.addedFlightDetails.flightDetails.push({'flightLegId': flight.flightLegId, 'aircraftId': data.registrationID});
                                  });
                                }
                                vm.selctedFlight.top = 5;
                                $timeout(function () {
                                  setFlightAircraftRegIdOfPair(vm.selctedFlight,data.registrationID);
                                  vm.flightRotationData[id].pairs.push(vm.selctedFlight);
                                }, 0);

                              } else{
                                if (vm.selectedType === 'available') {
                                  reLoadFlightRotationData()
                                }
                                else if (vm.selectedType === 'open') {
                                  reloadOpenFlight();
                                }
                                clearSelectableRows();
                                deferred.reject();
                              }
                            }
                            clearSelectableRows();

                          }
                          else {

                            confirmNotmatchAircraftRegAssign(e, dragEle, data, id);
                          }
                      }
                	}
                };

                function confirmNotmatchAircraftRegAssign(e, dragEle, data, id) {
                  vm.position = {e:e,dragEle:dragEle,data: data,id:id}

                  var details = {
                    title: 'Confirmation',
                    messages: ["Aircraft Model mismatched, are you sure you want to continue?"]

                  };
                  PopupManager.openModal('CONFIRM_DIALOG', details, validateMismatchedACUpdate);

                }

                function validateMismatchedACUpdate(result) {
                  if(result === 'YES'){
                    validateCrewFleetExperience();

                  }else{
                    setAsPrevious();
                  }

                }

                function validateCrewFleetExperience() {
                  var assignedCrew = [];

                    FlightWatch.loadFlightAssignedCrew(vm.selctedFlight.left[0].flightLegId,
                      function (response) {
                        assignedCrew = response;
                        checkFleetValidation(assignedCrew);

                      },
                      function () {
                        console.log('load flight assigned crew error');
                      })

                }

                function checkFleetValidation(assignedCrew) {
                  vm.illegalCrew = [];

                  angular.forEach(assignedCrew, function (crew) {
                     var crewFleet = crew.fleetExperience === null? "":crew.fleetExperience;

                    if(crewFleet.indexOf(vm.position.data.modelNumber) === -1) {
                      vm.illegalCrew.push(crew);
                    }

                  });

                  if(vm.illegalCrew.length > 0){
                    var params={
                      modelNumber:vm.position.data.modelNumber,
                      crewList:vm.illegalCrew
                    }
                    PopupManager.openModal('CONFIRM_ILLEGAL_FLEET_CREW_ASSIGN',params,confirmValidateCrewFleetExperience);

                  }else {
                    dragAndSave(vm.position.e, vm.position.dragEle, vm.position.data, vm.position.id);
                  }


                }

                function confirmValidateCrewFleetExperience(result) {
                  if(result === 'YES'){
                    dragAndSave(vm.position.e, vm.position.dragEle, vm.position.data, vm.position.id);

                  }else{
                    setAsPrevious();
                  }
                }

                function setAsPrevious() {
                  if (vm.selectedType === 'available') {
                    clearSelectableRows();
                    EventManagerService.notifyEventListeners("remove.flight.leg.from.rotation",
                      {'flightLegId': vm.selctedFlight.left[0].flightLegId ,'aircraftId': vm.selctedFlight.left[0].aircraftId});
                    setFlightAircraftRegIdOfPair(vm.selctedFlight,vm.selctedFlight.left[0].aircraftId);
                    EventManagerService.notifyEventListeners("add.flight.leg.to.rotation",
                      {'flightPair': vm.selctedFlight,'aircraftId': vm.selctedFlight.left[0].aircraftId});
                  }
                  else if (vm.selectedType === 'open') {
                    vm.openFlightData.splice(vm.draggedFlightId, 1);
                    reloadOpenFlight();
                  }
                }




                function dragAndSave(e, dragEle, data, id) {
                  EventManagerService.notifyEventListeners("remove.flight.leg.from.rotation",
                    {'flightLegId': vm.selctedFlight.left[0].flightLegId ,'aircraftId': vm.selctedFlight.left[0].aircraftId});

                  if(vm.selectedType != 'open'){
                    if (!!vm.selctedFlight.left) {
                      angular.forEach(vm.selctedFlight.left, function (flight) {
                        vm.addedFlightDetails.flightDetails.push({'flightLegId': flight.flightLegId, 'aircraftId': data.registrationID,'mismatchAircraft':true, 'modelNo':data.modelNumber});
                      });
                    }
                    if (!!vm.selctedFlight.right) {
                      angular.forEach(vm.selctedFlight.right, function (flight) {
                        vm.addedFlightDetails.flightDetails.push({'flightLegId': flight.flightLegId, 'aircraftId': data.registrationID,'mismatchAircraft':true, 'modelNo':data.modelNumber});
                      });
                    }
                    vm.selctedFlight.top = 5;
                    setFlightAircraftRegIdOfPair(vm.selctedFlight,data.registrationID);
                    EventManagerService.notifyEventListeners("add.flight.leg.to.rotation",
                      {'flightPair': vm.selctedFlight,'aircraftId': data.registrationID});

                    //                				vm.flightRotationData[id].pairs.push(vm.selctedFlight);
                  }
                  var dropElePos = dragEle.position.top;
                  var creScheduleTop = angular.element('.canvas').position().top + 60;
                  var openParingPanelTop = angular.element('.bottom-content').position().top - 20;

                  if(vm.selectedType === 'open'){
                    vm.openFlightData.splice(vm.draggedFlightId, 1);
                    vm.draggedFlightId="";

                    if (dropElePos > creScheduleTop && dropElePos < openParingPanelTop) {
                      if (!!vm.selctedFlight.left) {
                        angular.forEach(vm.selctedFlight.left, function (flight) {
                          vm.addedFlightDetails.flightDetails.push({'flightLegId': flight.flightLegId, 'aircraftId': data.registrationID,'mismatchAircraft':true, 'modelNo':data.modelNumber});
                        });
                      }
                      if (!!vm.selctedFlight.right) {
                        angular.forEach(vm.selctedFlight.right, function (flight) {
                          vm.addedFlightDetails.flightDetails.push({'flightLegId': flight.flightLegId, 'aircraftId': data.registrationID,'mismatchAircraft':true, 'modelNo':data.modelNumber});
                        });
                      }
                      vm.selctedFlight.top = 5;
                      $timeout(function () {
                        setFlightAircraftRegIdOfPair(vm.selctedFlight,data.registrationID);
                        vm.flightRotationData[id].pairs.push(vm.selctedFlight);
                      }, 0);

                    } else{
                      if (vm.selectedType === 'available') {
                        reLoadFlightRotationData()
                      }
                      else if (vm.selectedType === 'open') {
                        reloadOpenFlight();
                      }
                      clearSelectableRows();
                      deferred.reject();
                    }
                  }
                  clearSelectableRows();

                }

                function setFlightAircraftRegIdOfPair(flightPair,aircraftId){
                	angular.forEach(flightPair.left, function (left) {
                		left.aircraftId = aircraftId;
            	    });

                	angular.forEach(flightPair.right, function (right) {
                		right.aircraftId = aircraftId;
            	    });
                }

                function getAddjustedTime(minutesDiffFromPrevious){
                	var timeGapValueInMinutes = 1;
                	if(minutesDiffFromPrevious >= 0){
                		return Math.round(minutesDiffFromPrevious/timeGapValueInMinutes)*timeGapValueInMinutes;
                	}else{
                		return ( Math.round(Math.abs(minutesDiffFromPrevious)/timeGapValueInMinutes)*timeGapValueInMinutes ) * -1;
                	}
                }

                function updateSelectedCheck(currentPosition,aircraftData) {
                    var diffFromPrevious, startDate, currentStartTime, endDate, currentEndTime;

                    diffFromPrevious = (vm.dragEndPoint - vm.dragStartPoint) / vm.minuteToPixelRatio;
                    startDate = moment(vm.selectedCheck.checkStartDate + ' ' + vm.selectedCheck.checkStartTime, "DD/MM/YYYY HH:mm");
                    endDate = moment(vm.selectedCheck.checkEndDate + ' ' + vm.selectedCheck.checkEndTime, "DD/MM/YYYY HH:mm");
                    diffFromPrevious = getAddjustedTime(diffFromPrevious);


                    if(diffFromPrevious >0){
                        currentStartTime = moment(startDate).add(diffFromPrevious, 'm');
                        currentEndTime = moment(endDate).add(diffFromPrevious, 'm');
                    }
                    else{
                        currentStartTime = moment(startDate).subtract(Math.abs(diffFromPrevious), 'm');
                        currentEndTime = moment(endDate).subtract(Math.abs(diffFromPrevious), 'm');
                    }

//                    currentPosition = currentPosition + diffFromPrevious;
//                    lastOffsetOfCheck = lastOffsetOfCheck + diffFromPrevious;

//                    vm.selectedCheck.leftPos = getTimeInMinFromStartDate(checkDetails.checkStartDate, checkDetails.checkStartTime, vm.cal_start);
                    vm.selectedCheck.checkStartDate = moment(currentStartTime).format("DD/MM/YYYY ");
                    vm.selectedCheck.checkStartTime = moment(currentStartTime).format("HH:mm");
                    vm.selectedCheck.checkEndDate = moment(currentEndTime).format("DD/MM/YYYY ");
                    vm.selectedCheck.checkEndTime = moment(currentEndTime).format("HH:mm");
                    vm.selectedCheck.leftPos = getTimeInMinFromStartDate(vm.selectedCheck.checkStartDate, vm.selectedCheck.checkStartTime, vm.cal_start);

                    vm.selectedCheck.notOverlap = isNotOverlapWithCheckOrPairing(vm.selectedCheck, aircraftData);

                    vm.flightRotationData[vm.previosRowNo].checks.push(vm.selectedCheck);

                    if(vm.selectedCheck.aircraftRegCheckId && vm.selectedCheck.aircraftRegCheckId > 0){
                    	editUpdateCheckInfo();
                    }else{
                    	editNewCheckInfo();
                    }

                    vm.flightRotationData[vm.previosRowNo].isDropableContainer = false;
                }

                function editUpdateCheckInfo(){
                	 removeUpdatedCheckIfAlreadyExist(vm.selectedCheck.aircraftRegCheckId);
                     vm.addedFlightDetails.updatedChecks.push({
                         "aircraftRegId": vm.selectedCheck.aircraftRegId,
                         "dailyFlag": vm.selectedCheck.dailyFlag,
                         "weeklyFlag": vm.selectedCheck.weeklyFlag,
                         "othersFlag": vm.selectedCheck.othersFlag,
                         "checkDesc": vm.selectedCheck.checkDesc,
                         "checkStartDate": vm.selectedCheck.checkStartDate,
                         "checkStartTime": vm.selectedCheck.checkStartTime,
                         "checkEndDate":vm.selectedCheck.checkEndDate,
                         "checkEndTime": vm.selectedCheck.checkEndTime,
                         "aircraftRegCheckId": vm.selectedCheck.aircraftRegCheckId,
                         "version": vm.selectedCheck.version
                     });
                }

                function removeUpdatedCheckIfAlreadyExist(checkId){

                	var regCheck =_.findWhere(vm.addedFlightDetails.updatedChecks, {aircraftRegCheckId: checkId});
                	if(regCheck){
                		var regCheckIndex = _.indexOf(vm.addedFlightDetails.updatedChecks,regCheck);
                		vm.addedFlightDetails.updatedChecks.splice( regCheckIndex, 1 );
                	}
                }

                function removeNewCheckIfAlreadyExist(checkId){

                	var regCheck =_.findWhere(vm.addedFlightDetails.newChecks, {aircraftRegCheckId: checkId});
                	if(regCheck){
                		var regCheckIndex = _.indexOf(vm.addedFlightDetails.newChecks,regCheck);
                		vm.addedFlightDetails.newChecks.splice( regCheckIndex, 1 );
                	}
                }



                function editNewCheckInfo(){
                	removeNewCheckIfAlreadyExist(vm.selectedCheck.aircraftRegCheckId);
                	vm.addedFlightDetails.newChecks.push({
                         "aircraftRegId": vm.selectedCheck.aircraftRegId,
                         "dailyFlag": vm.selectedCheck.dailyFlag,
                         "weeklyFlag": vm.selectedCheck.weeklyFlag,
                         "othersFlag": vm.selectedCheck.othersFlag,
                         "checkDesc": vm.selectedCheck.checkDesc,
                         "checkStartDate": vm.selectedCheck.checkStartDate,
                         "checkStartTime": vm.selectedCheck.checkStartTime,
                         "checkEndDate":vm.selectedCheck.checkEndDate,
                         "checkEndTime": vm.selectedCheck.checkEndTime,
                         "aircraftRegCheckId": vm.selectedCheck.aircraftRegCheckId
                     });
                }


                vm.onBeforeDragFlight = function (e, dragEle, selectedFlight, parentID, type, modelNo, id) {

                    angular.element(e.target).addClass("selected-pair");
                    vm.selctedFlight = selectedFlight;
                    vm.selctedFlight.modelNo = modelNo;
                    vm.previosRowNo = parentID;
                    vm.selectedType = type;
                    setSelectableRows(modelNo);
//                    EventManagerService.notifyEventListeners("remove.flight.leg.from.rotation",
//    						{'flightLegId': vm.selctedFlight.left[0].flightLegId ,'aircraftId': vm.selctedFlight.left[0].aircraftId});
                };

                vm.onDragCheck = function(event, ui ,ele){

                	 var offset = $('.left-section').offset();
                     var width =  $('.left-section').width();

                     var dragInitLeftPosition = offset.left + width;
                     var elementLeftPosisition =ui.offset.left;
                     var elementRightPosisition = ui.helper.width() + elementLeftPosisition ;


                     if(dragInitLeftPosition >  elementLeftPosisition  ){
                   	  	var leftOffset = $(".right-section").scrollLeft();
                    	$(".right-section ").scrollLeft(leftOffset-75);
                     }

                     var windowWidth =  $(window).width();
                     var dragInitRightPosition = windowWidth;

                     if(elementRightPosisition > dragInitRightPosition ){
                    	var leftOffset = $(".right-section").scrollLeft();
                        $(".right-section ").scrollLeft(leftOffset+75);
                     }

                }

                vm.scrollToDropArea = function(event, ui ,ele){
                  $('.tooltip').remove();

                  var offset = $('.top-header').offset();
                  var height =  $('.top-header').height();

                  var topDragInitTopPosition = offset.top + height;
                  var elementBottomPosisition = ui.helper.height() + ui.offset.top ;

                  if(topDragInitTopPosition >  ( elementBottomPosisition + 15)  ){
                	  var topOffset = $(".right-section").scrollTop();
                 	  $(".right-section ").scrollTop(topOffset-50);
                  }

                  var offsetCanvas = $('.canvas').offset();
                  var heightCanvas =  $('.canvas').height();

                  var dragInitBottomPosition = offsetCanvas.top + heightCanvas;

                  if(elementBottomPosisition > dragInitBottomPosition ){
                	  var topOffset = $(".right-section").scrollTop();
                 	  $(".right-section ").scrollTop(topOffset+50);
                  }

                };

                vm.onDragOpenFlight = function(event, ui ,ele){
                  $('.tooltip').remove();
                  var offset = $('.top-header').offset();
                  var height =  $('.top-header').height();

                  var topDragInitTopPosition = offset.top + height;
                  var elementBottomPosisition = ui.helper.height() + ui.offset.top + 15 ;

                  if(topDragInitTopPosition > elementBottomPosisition ){
                	  var topOffset = $(".right-section").scrollTop();
                 	  $(".right-section ").scrollTop(topOffset-50);
                  }
                };

                vm.onBeforeDragCheck = function (e, dragEle, selectedCheck, parentID, type, id) {
                	vm.dragStartPoint = e.pageX - $(".right-section-table").offset().left;
                    vm.selectedCheck = selectedCheck;
                    vm.previosRowNo = parentID;
                    vm.selectedType = type;
                    vm.flightRotationData[parentID].isDropableContainer = true;
                    vm.flightRotationData[parentID].checks.splice(id, 1);
                    vm.selectedCheck.edited = true;
                };


                vm.onDragStop = function(e, ui){
                	vm.dragEndPoint = e.pageX - $(".right-section-table").offset().left;
                }

              // get selected flight leg indexes
              vm.checkIsMultiSeleted = function(event, parentIndex, index, pairDetail) {
                if (event.ctrlKey || event.metaKey) {
                  blockClickWithCtrlKey(event, parentIndex, index, pairDetail);
                } else {
                  singleBlockClick(event, parentIndex, index, pairDetail);
                }
                vm.previousSelectPairDetail = pairDetail;
              };

              vm.getSelectedPairDetails = function(){
                var sendNotificationDetails = {};

                var notificationItems = [];
                vm.selectedPairDetails.forEach(function(p){
                  if(p.isSelected) {
                    var notificationItem = {
                      flightLegId : p.flightLegId
                    };

                    notificationItems.push(notificationItem);
                  }
                });
                sendNotificationDetails.notificationItems =notificationItems;
                sendNotificationDetails.successCallback = vm.clearSelectedItems;
                return sendNotificationDetails;
              };

              vm.clearSelectedItems = function(){
                vm.selectedPairDetails.length = 0;
              };

              EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.SEND_CREW_NOTIFICATION, function (data) {
                if (data.modelValue.notificationItems.length == 0){
                  data.items.pairDetails.isSelected = true;
                  vm.selectedPairDetails.push(data.items.pairDetails);
                  var notificationItem = {
                    flightLegId : data.items.pairDetails.flightLegId
                  };
                  data.modelValue.notificationItems.push(notificationItem);
                }
                PopupManager.openModal('FLIGHT_SEND_NOTIFICATION', data, function () {
                });
              });

              vm.checkIsSelected = function(pairDetail){
                var result = false;
                // search for existing object
                var selectedPairDetail = _.find(vm.selectedPairDetails, function (obj) {
                  return obj.flightLegId === pairDetail.flightLegId;
                });

                if(selectedPairDetail !== undefined){
                  result = selectedPairDetail.isSelected;
                }
                return result;
              };


              function singleBlockClick(event, parentIndex, index, pairDetail) {
                // search for existing object
                var selectedPairDetail = _.find(vm.selectedPairDetails, function (obj) {
                     return obj.flightLegId === pairDetail.flightLegId;
                });

                // reset the array
                vm.selectedPairDetails.length = 0;

                // another click
                if(selectedPairDetail === undefined){
                    pairDetail.isSelected = true;
                    vm.selectedPairDetails.push(pairDetail);
                } else {
                  pairDetail.isSelected = !selectedPairDetail.isSelected;
                  vm.selectedPairDetails.push(pairDetail);
                }
              }

              function blockClickWithCtrlKey(event, parentIndex, index, pairDetail) {

                var selectedPairDetail = _.find(vm.selectedPairDetails, function (obj) {
                  return obj.flightLegId === pairDetail.flightLegId
                });

                if(selectedPairDetail === undefined){
                  pairDetail.isSelected = true;
                  vm.selectedPairDetails.push(pairDetail);
                }else {
                  var index = vm.selectedPairDetails.indexOf(selectedPairDetail);
                  vm.selectedPairDetails[index].isSelected = !selectedPairDetail.isSelected;
                }
              }

              function reloadOpenFlight() {
                  $timeout(function () {
                  vm.openFlightData.push(vm.selctedFlight);
                  }, 0);
              }

              function reLoadFlightRotationData() {
                  vm.flightRotationData[vm.previosRowNo].pairs.push(vm.selctedFlight);
              }

              vm.onDropOver = function (e, dragEle, data, id) {
              };

              vm.onDropOut = function (e) {
              };

              function setSelectableRows(modelNo) {
                angular.forEach(vm.flightRotationData, function (rotationData) {
                    rotationData.isDropableContainer = (rotationData.modelNumber == modelNo);
                    rotationData.selectedAircraft = false;

                });
              }

              function clearSelectableRows() {
                angular.forEach(vm.flightRotationData, function (rotationData) {
                    rotationData.isDropableContainer = false;
                });
              }

              function saveRotation() {

            	if (vm.flightRotationData == null || !vm.flightRotationData.length > 0) {
					var warning = "Please Search Or Do Auto Rotation For Save Rotation Changes";
					MessageService.warning(warning);
        			return;
            	}

                if (!!vm.addedFlightDetails && (vm.addedFlightDetails.updatedChecks.length ||vm.addedFlightDetails.newChecks.length ||vm.addedFlightDetails.flightDetails.length ||vm.addedFlightDetails.deletedChecks.length) ) {
                    vm.addedFlightDetails.timeZone = vm.timeZone;
                    FlightWatch.saveRotation(vm.addedFlightDetails,
                        function (response) {
                            vm.addedFlightDetails.flightDetails = [];
                            vm.addedFlightDetails.timeZone = vm.timeZone;
                            vm.addedFlightDetails.updatedChecks = [];
                            vm.addedFlightDetails.newChecks = [];
                            vm.addedFlightDetails.deletedChecks = [];
                            MessageService.success(MessageService.MESSAGES.FLIGHT.UPDATE_FLIGHT_SUCCESS);
                            EventManagerService.notifyEventListeners("show.open.flight.view", false);
                            reloadRotation();
                        },
                        function () {
                            console.log('save rotation error');
                        })
                }
                else {
                    MessageService.warning(MessageService.MESSAGES.FLIGHT.UPDATE_FLIGHT_FORM_NOT_TOUCH);
                }
              }

              function validateSendEmailRequest(){
                if(angular.isUndefined(vm.fromDate)|| vm.fromDate === null ||
                vm.toDate === null||angular.isUndefined(vm.toDate)){
                  return false;
                }

                return true;
              }

              function setEmailSendRequest(){
                var req = {
                          fromDate:vm.fromDate,
                          toDate:vm.toDate,
                          baseAirport: null,
                          airport: null,
                          aircraftModel:null,
                          viewOption:null,
                          timeZone:null
                      };
                return req;
              }

              vm.onClickSlotMessageIcon = function (e, pairDetails, rowIndex) {
                  if(vm.popOverModel != undefined && vm.popOverModel.flightID != undefined){
                      vm.popOverRequestFlightId[vm.popOverModel.flightID] = false
                }
                vm.popOverRequestFlightId[pairDetails.flightId] = true;
                var findPosition = function () {
                  var H = 'left', V = 'top';
                  if ((e.clientX + e.target.offsetWidth + 100) > vm.screen_right_panel) {
                    H = 'left';
                  } else {
                    H = 'right';
                  }
                  if ((e.clientY + e.target.offsetHeight + 100) > vm.comHeight) {
                    V = 'bottom';
                  } else {
                    V = 'top';
                  }
                  return H + '-' + V;
                };
                var isOverlap = false
                if (rowIndex !== 0) {
                  isOverlap = true;
                }
                vm.popOverModel.placement = findPosition(),
                  vm.popOverModel.isOverlap = isOverlap,
                  vm.popOverModel.isOpen = true

                vm.loadSlotMessageForPopOver(pairDetails.flightLegId);
              };

              vm.loadSlotMessageForPopOver = function (flightLegId) {

                FlightWatch.loadLatestSlotMessageByFlightLegId(flightLegId, function (slotRawMessage) {
                  vm.popOverModel.slotMessage = slotRawMessage.slotRawMessage;

                  var status = (slotRawMessage.processStatus).toLowerCase();
                  var lStatus = status.replace(/_/g, ' ');
                  var fStatus = (lStatus.charAt(0).toUpperCase() + lStatus.slice(1));

                  if(lStatus=='not required'){
                    fStatus='Not Required';
                  }

                  vm.popOverModel.slotMessageProcessStatus = "Process Status" + " : " +  fStatus;
                  vm.popOverModel.flightID = slotRawMessage.flightId;
                });

              };

              vm.closeSlotMessagePopover = function (flightId) {
                vm.popOverRequestFlightId[flightId] = false;

              };

              vm.isOpenSlotMessagePopOver = function (flightId) {
                var open = vm.popOverRequestFlightId[flightId];

                if(open != null && open){
                  vm.popOverRequestFlightId[flightId] = true;
                  return true;

                }

                return false;
              };

              vm.clickOnAircraft = function(id){
                  angular.forEach(vm.flightRotationData, function (rotationData) {
                      rotationData.selectedAircraft = false;
                      rotationData.isDropableContainer = false;
                  });
                  vm.selctedFlightIDforCheck= id;
                  vm.flightRotationData[id].selectedAircraft = true;
                  vm.selectedAircraft = vm.flightRotationData[id];
                  vm.selectedAnyAircraft = true;
                };

                vm.onClickSetting = function(id){

                    vm.dynamicPopover4 = {
                        content: '',
                        templateUrl: 'configure_aircraft.tpl.html',
                        title: 'Title'
                    };
                };

                vm.hoverIn = function(id){
                    angular.forEach(vm.flightRotationData, function (rotationData,key) {
                        rotationData.showSetting = (key === id);

                    });
                };

                vm.hoverOut = function(id){
                    angular.forEach(vm.flightRotationData, function (rotationData,key) {
                        rotationData.showSetting = false;

                    });
                };

                function showRotationSummaryPopUp(){
                	var modalParam = {
                    		fullScheduleList: vm.fullScheduleList
                    };
                    PopupManager.openModal('ROTATION_SUMMARY_POPUP', modalParam, closedSummaryPopUp);
                }

                function closedSummaryPopUp() {
                	//nothing to do
                }

                function openFlightCheckPopUp(){

                	if (vm.flightRotationData == null || !vm.flightRotationData.length > 0) {
            			var warning = "Please Search Or Do Auto Rotation For New Check";
            			MessageService.warning(warning);
            			return;
            		}

                    vm.checkTypeStatus = 'new';
                    if(vm.selectedAnyAircraft){
                        var modalParam={
                            airCraft:vm.selectedAircraft,
                            type:vm.checkTypeStatus,
                            checkDetails :{}
                        };
                        PopupManager.openModal('ADD_CHECK_POPUP', modalParam, updateCheckDetails);
                    } else{
                        MessageService.warning(MessageService.MESSAGES.FLIGHT.ADD_CHECKS_1);
                    }
                }

                function openFlightEditCheckPopUp(){
                    vm.checkTypeStatus = 'edit';
                    vm.selectedAircraft = vm.flightRotationData[vm.selctedFlightIDforCheck];
                    var modalParam = {
                      airCraft: vm.selectedAircraft,
                      type: vm.checkTypeStatus,
                      checkDetails: vm.checkDetails
                    };
                    PopupManager.openModal('ADD_CHECK_POPUP', modalParam, updateCheckDetails);
                }

                function updateCheckDetails(checkParam) {
                  if(checkParam){
                    var checkDetails = checkParam.checkDetails;
                    var airCraft = checkParam.airCraft;
                    var currentTimeInMillis = -1 * ( new Date().getTime())

                    if(checkDetails && airCraft) {
                      if (vm.checkTypeStatus === 'new') {
                        vm.addedFlightDetails.newChecks.push({
                          "aircraftRegId": checkDetails.aircraftRegId,
                          "dailyFlag": checkDetails.dailyFlag,
                          "weeklyFlag": checkDetails.weeklyFlag,
                          "othersFlag": checkDetails.othersFlag,
                          "checkDesc": checkDetails.checkDesc,
                          "checkStartDate": checkDetails.checkStartDate,
                          "checkStartTime": checkDetails.checkStartTime,
                          "checkEndDate": checkDetails.checkEndDate,
                          "checkEndTime": checkDetails.checkEndTime,
                          "aircraftRegCheckId": currentTimeInMillis
                        });

                        checkDetails.edited = true;
                        checkDetails.displayLabel = getCheckDisplayLabel(checkDetails);
                        checkDetails.aircraftRegCheckId = currentTimeInMillis;
                        checkDetails.leftPos = 0;
                        checkDetails.top = 0;
                        checkDetails.widthInPx = 0;
                        checkDetails.leftPos = getTimeInMinFromStartDate(checkDetails.checkStartDate, checkDetails.checkStartTime, vm.cal_start);
                        var tmpCheckEndInPx = getTimeInMinFromStartDate(checkDetails.checkEndDate, checkDetails.checkEndTime, vm.cal_start);
                        checkDetails.widthInPx = tmpCheckEndInPx - checkDetails.leftPos;

                        //isOverlap check
                        checkDetails.notOverlap = isNotOverlapWithCheckOrPairing(checkDetails, airCraft);

                        vm.flightRotationData[vm.selctedFlightIDforCheck].checks.push(checkDetails);
                        vm.flightRotationData[vm.selctedFlightIDforCheck].selectedAircraft = false;
                      }  else if(vm.checkTypeStatus === 'edit' && checkDetails.aircraftRegCheckId < 0){
                    	  var a = _.where(vm.addedFlightDetails.newChecks, {aircraftRegCheckId: checkDetails.aircraftRegCheckId});
                    	  if (a.length) {
                              a[0].aircraftRegId = checkDetails.aircraftRegId;
                              a[0].dailyFlag = checkDetails.dailyFlag;
                              a[0].weeklyFlag = checkDetails.weeklyFlag;
                              a[0].othersFlag = checkDetails.othersFlag;
                              a[0].checkDesc = checkDetails.checkDesc;
                              a[0].checkStartDate = checkDetails.checkStartDate;
                              a[0].checkStartTime = checkDetails.checkStartTime;
                              a[0].checkEndDate = checkDetails.checkEndDate;
                              a[0].checkEndTime = checkDetails.checkEndTime;
                           }

                    	  checkDetails.edited = true;
                    	  checkDetails.displayLabel = getCheckDisplayLabel(checkDetails);
                          checkDetails.leftPos = 0;
                          checkDetails.widthInPx = 0;
                          checkDetails.leftPos = getTimeInMinFromStartDate(checkDetails.checkStartDate, checkDetails.checkStartTime, vm.cal_start);
                          var tmpCheckEndInPx = getTimeInMinFromStartDate(checkDetails.checkEndDate, checkDetails.checkEndTime, vm.cal_start);
                          checkDetails.widthInPx = tmpCheckEndInPx - checkDetails.leftPos;

                          //isOverlap check
                          checkDetails.notOverlap = isNotOverlapWithCheckOrPairing(checkDetails, airCraft);

                          vm.flightRotationData[vm.selctedFlightIDforCheck].checks[vm.slectedCheckIndex] = checkDetails;

                      } else {
                        if (checkDetails.aircraftRegCheckId !== undefined) {
                          var a = _.where(vm.addedFlightDetails.updatedChecks, {aircraftRegCheckId: checkDetails.aircraftRegCheckId});
                          if (a.length) {
                            a[0].aircraftRegId = checkDetails.aircraftRegId;
                            a[0].dailyFlag = checkDetails.dailyFlag;
                            a[0].weeklyFlag = checkDetails.weeklyFlag;
                            a[0].othersFlag = checkDetails.othersFlag;
                            a[0].checkDesc = checkDetails.checkDesc;
                            a[0].checkStartDate = checkDetails.checkStartDate;
                            a[0].checkStartTime = checkDetails.checkStartTime;
                            a[0].checkEndDate = checkDetails.checkEndDate;
                            a[0].checkEndTime = checkDetails.checkEndTime;
                            a[0].aircraftRegCheckId = checkDetails.aircraftRegCheckId;
                            a[0].version = checkDetails.version;
                          } else {
                            vm.addedFlightDetails.updatedChecks.push({
                              "aircraftRegId": checkDetails.aircraftRegId,
                              "dailyFlag": checkDetails.dailyFlag,
                              "weeklyFlag": checkDetails.weeklyFlag,
                              "othersFlag": checkDetails.othersFlag,
                              "checkDesc": checkDetails.checkDesc,
                              "checkStartDate": checkDetails.checkStartDate,
                              "checkStartTime": checkDetails.checkStartTime,
                              "checkEndDate": checkDetails.checkEndDate,
                              "checkEndTime": checkDetails.checkEndTime,
                              "aircraftRegCheckId": checkDetails.aircraftRegCheckId,
                              "version": checkDetails.version
                            });
                          }


                          checkDetails.edited = true;
                          checkDetails.displayLabel = getCheckDisplayLabel(checkDetails);

                          checkDetails.leftPos = 0;
                          checkDetails.widthInPx = 0;
                          checkDetails.leftPos = getTimeInMinFromStartDate(checkDetails.checkStartDate, checkDetails.checkStartTime, vm.cal_start);
                          var tmpCheckEndInPx = getTimeInMinFromStartDate(checkDetails.checkEndDate, checkDetails.checkEndTime, vm.cal_start);
                          checkDetails.widthInPx = tmpCheckEndInPx - checkDetails.leftPos;

                          //isOverlap check
                          checkDetails.notOverlap = isNotOverlapWithCheckOrPairing(checkDetails, airCraft);


                          vm.flightRotationData[vm.selctedFlightIDforCheck].checks[vm.slectedCheckIndex] = checkDetails;
                        }
                      }
                    }
                  }
                }

                function isNotOverlapWithCheckOrPairing(checkDetails, airCraft) {
                    var notOverLapCheck = true;
                    var leftPos = checkDetails.leftPos;
                    var rightPos = leftPos + checkDetails.widthInPx;

                    // check with pairs
                    angular.forEach(airCraft.checks, function(value, key){
                      if(checkDetails.aircraftRegCheckId !== value.aircraftRegCheckId) {
                        var chLeftPos = value.leftPos;
                        var chRightPos = chLeftPos + value.widthInPx;
                        if ((leftPos < chRightPos) && (chLeftPos < rightPos)) {
                          notOverLapCheck = false;
                        }
                      }
                    });

                    // check with pairs
                    angular.forEach(airCraft.pairs, function(value, key){
                      var paLeftPos = value.leftPos;
                      var paRightPos = paLeftPos + value.widthInPx;
                      if((leftPos < paRightPos) && (paLeftPos < rightPos)){
                        notOverLapCheck = false;
                      }
                    });

                    return notOverLapCheck;
                }

                function getCheckDisplayLabel(checkDetails){
                  var displayLabel = checkDetails.checkDesc;
                    if(displayLabel.length > 6){
                      displayLabel = displayLabel.substring(0,6) +"...";
                    }
                    return displayLabel;
                }

                vm.onReloadOpenParingsClick = function () {
                    if(vm.addedFlightDetails.updatedChecks.length ||vm.addedFlightDetails.newChecks.length ||vm.addedFlightDetails.flightDetails.length ){
                        MessageService.warning(MessageService.MESSAGES.FLIGHT.RELOAD_ERROR);
                    }
                    else{
                        vm.clickOnReloadOpenFlights();
                    }

                };

                function reloadRotation(){

//                    if((vm.addedFlightDetails.updatedChecks.length ||vm.addedFlightDetails.newChecks.length ||vm.addedFlightDetails.flightDetails.length) && !vm.autoRefresh){
//                        MessageService.warning(MessageService.MESSAGES.FLIGHT.RELOAD_ERROR);
//                    }
//                    else{
                        vm.autoRefresh = false;
                        vm.loadFlightRotationData();
                        angular.element('.right-section').scrollLeft(0);
                        angular.element('.left-section').scrollTop(0);
//                    }
                }

                function onTimeLineRefresh(){
                	vm.autoRefresh = false;
                	vm.loadFlightRotationData();
                	angular.element('.right-section').scrollLeft(0);
                	angular.element('.left-section').scrollTop(0);
                }

//          automatic refresh option handling
//          default - off
                function refreshRotationData(data){
                    //alert(data.value);
                    if(data.value === '0'){
                        $interval.cancel(vm.refreshTimer);
                        $interval.cancel(vm.notificationTimer);
                        $interval.cancel(vm.decreaseCounter);

                    }
                    else{
                        vm.userActive = false;
                        vm.refreshTime = parseInt(data.value) * 60000 ;
                        vm.notificationTime = vm.refreshTime - 30000;  //  for give alert to user system going to refresh

                        $interval.cancel(vm.refreshTimer);
                        $interval.cancel(vm.notificationTimer);
                        $interval.cancel(vm.decreaseCounter);
                        startRefreshTimer();
                        startNotificationTimer();

                        angular.element(document).bind('mousemove click mouseup mousedown keydown keypress keyup submit change mouseenter scroll resize dblclick', function () {
                            vm.userActive= true;
                        });
                    }

                }

                function startRefreshTimer(){
                    vm.refreshTimer = $interval(function () {
                        if(!!vm.flightRotationData){
                            if(vm.userActive){
                                vm.autoRefresh =true;
                                vm.isNotification = false;
                                //reloadRotation();
                                onTimeLineRefresh();
                                $interval.cancel(vm.decreaseCounter);
                                $interval.cancel(vm.notificationTimer);
                                startNotificationTimer();

                            }
                        }
                    }, vm.refreshTime);
                }

                function startNotificationTimer(){
                    vm.notificationTimer = $interval(function () {
                        if(!!vm.flightRotationData){
                            if(vm.userActive){
                                vm.isNotification = true;
                                vm.counter = 30;
                                 $interval.cancel(vm.decreaseCounter);
                               decreaseCounter()
                            }
                        }
                    }, vm.notificationTime);
                }

                vm.resetRefreshTimer = function(){
                    vm.userActive =false;
                    vm.isNotification = false;
                    $interval.cancel(vm.refreshTimer);
                    $interval.cancel(vm.notificationTimer);
                    startRefreshTimer();
                    startNotificationTimer();
                };

                function decreaseCounter() {
                    vm.decreaseCounter = $interval(function () {
                        vm.counter = vm.counter - 1;
                        if(vm.counter === 0){
                            vm.isNotification = false;
                        }
                    },1000,30);
                };

                /*function sendRotationChageEmail(){
                	if(!validateSendEmailRequest()){
                		return MessageService.error('From date and To date cannot be blank');
                	}
                	var request = setEmailSendRequest();

                	FlightWatch.sendRotationChangeEmail(request,
                          function (response) {
                              MessageService.success(MessageService.MESSAGES.FLIGHT.EMAIL_SENT_SUCCESS);
                      },
                       function () {
                    	  MessageService.error('send rotation change email error');
                   });

                };

                function sendRotationEmail(){

                	if(!validateSendEmailRequest()){
                		return MessageService.error('From date and to date cannot be blank');
                	}

                	var request = setEmailSendRequest();

                	FlightWatch.sendRotationEmail(request,
                          function (response) {
                              MessageService.success(MessageService.MESSAGES.FLIGHT.EMAIL_SENT_SUCCESS);
                      },
                       function () {
                         console.log('send rotation email error');
                   });
                };*/

                function sendRotationChageEmail(){
                	vm.sendRotationChangeEmail();
                };

                function sendRotationEmail(){
                	vm.sendRotationEmail();
                };


                vm.configureAircraft = function(){
                      //  alert(123)
                }
                function loadBaseType(){
                    CommonMasterData.getCrewBaseList(
                        function (crewBase) {
                            vm.baseType = crewBase;
                        }, function () {

                        }
                    )
                }
                function getAeroOpsEnableParam(){
                  CommonMasterData.getAeroOpsEnableParam(
                    function (ep) {
                      if(angular.equals(ep.paramValue,"Y")){
                        vm.aeroOpsEnableParam = true;
                      }

                    },
                    function () {
                      console.log('AeroOps Enable Param retrieval error');
                    }
                  );
                }
            },
            bindings: {
                flightRotationData: '<',
                baseAirport: '<',
                viewMode: '<',
                fromDate: '<',
                toDate: '<',
                clickOnOpenFlight: '&',
                openFlightData: '<',
                timeZone: '<',
                openFlightButtonDisable: '<',
                clickOnReloadOpenFlights:'&',
                clickOnReloadRotation:'&',
                loadFlightRotationData : '&',
                currentTimeModel:'<',
                sendRotationChangeEmail:'&',
                sendRotationEmail:'&',
                airport:'<',
                aircraftModel: '<',
                viewOption : '<' ,
                fullScheduleList : '<'
            }

        });
})();
